import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';
import Login from '@/views/Login.vue';
import Dashboard from '@/views/Dashboard.vue';
import Notificacoes from '@/views/Notificacoes.vue';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login, meta: { guest: true } },
  { path: "/dashboard", component: Dashboard, meta: { requiresAuth: true } },
  { path: "/notificacoes", component: Notificacoes, meta: { requiresAuth: true } }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Cache de autenticação para evitar chamadas excessivas
let authChecked = false;
let isAuthenticated = false;

export function resetAuthState() {
  authChecked = false;
  isAuthenticated = false;
}

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!authChecked) {
      try {
        await axios.get('/api/user', {
          headers: { Accept: 'application/json' }
        });
        isAuthenticated = true;
      } catch {
        isAuthenticated = false;
      }
      authChecked = true;
    }

    if (!isAuthenticated) {
      return next('/login');
    }
  }

  // Se já está autenticado e tenta acessar login, redireciona para dashboard
  if (to.meta.guest && authChecked && isAuthenticated) {
    return next('/dashboard');
  }

  next();
});

export default router;
